module.exports = __webpack_public_path__ + "static/littleWomen10s-b3b151b9ae04a9764dabb47703ffdd08.jpg";